import React from "react";
import { Quote } from "lucide-react";
import "./stamp.css";
import DockStamps from "./DockStamps";

const REVIEWS = [
  {
    name: "David Chen",
    role: "Software Architect · Toronto",
    flag: "🇨🇦",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    quote: "NextShore made my Canadian PR journey seamless. From the first chat with Izzy to final approval, their guidance was unmatched.",
  },
  {
    name: "Maria Santos",
    role: "Healthcare Specialist · London",
    flag: "🇬🇧",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    quote: "Securing my UK Skilled Worker Visa felt daunting until NextShore. They supported me every step of the way.",
  },
  {
    name: "Amina Al-Mansoor",
    role: "Financial Analyst · Sydney",
    flag: "🇦🇺",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    quote: "The clarity and precision of NextShore turned my dream of living in Australia into reality in under six months.",
  },
  {
    name: "Rajesh Kumar",
    role: "Fintech Founder · Dubai",
    flag: "🇦🇪",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&w=400&q=80",
    quote: "Setting up our company's Golden Visas in Dubai was fast and efficient. NextShore is truly top tier.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 bg-app">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">Client Stories</span>
          <h2 className="font-serif text-3xl sm:text-4xl mt-3 leading-tight text-app">
            Real journeys. <em className="text-[#C9A961]">Real approvals.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`testimonial-${i}`}
              className="card-app rounded-2xl p-7 flex gap-5 hover:border-[#C9A961]/50 transition"
            >
              <div className="shrink-0">
                <div className="relative w-16 h-16 rounded-full overflow-hidden ring-2 ring-[#C9A961]/40">
                  <img src={r.img} alt={r.name} className="w-full h-full object-cover" />
                </div>
                <div className="mt-2 text-center text-lg">{r.flag}</div>
              </div>
              <div className="flex-1">
                <Quote className="w-5 h-5 text-[#C9A961]/60 mb-2" />
                <p className="text-app leading-relaxed text-[15px]">{r.quote}</p>
                <div className="mt-4">
                  <div className="font-serif text-lg text-app">{r.name}</div>
                  <div className="text-xs text-app-muted uppercase tracking-wider">{r.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Passport-stamp dock — driven by /api/testimonials */}
        <div className="mt-16">
          <DockStamps />
        </div>
      </div>
    </section>
  );
}
